module.exports = __webpack_public_path__ + "static/media/logoM.3384db17.svg";